import { View } from 'components/View'
import React from 'react'

export default function ContentBox (props) {
  return (
    <View
      mb={2}
      p={2}
      bdr
      bgc='background'
      {...props}
    />
  )
}
